import eliteService from "./../api/elite-service";
import redirect from "../uitls/redirect";
import { MESSAGES } from "../uitls/messages";
import { notifyError } from "../uitls/notification-helper";
import retry from "@/utils/retry";
import router from "@/router";
import youtubeApi from "./../api/youtube.js";
import Vue from "vue"

import {
  FEEDBACK_ICONS,
  FEEDBACK_MESSAGES,
  FEEDBACK_STICKER_ENABLED,
  FEEDBACK_STICKER_INTERVAL,
} from "../uitls/constants";

const getState = () => {
  return {
    title: null,
    videoId: null,
    videoIntervals: [],
    steps: [],
    url: null,
    videoLoaded: false,
    isVideoPlaying: true,
    caloriesBurnt: 0,
    accuracy: 0,
    duration: 0,
    successColor: null,
    errorColor: null,
    defaultColor: null,
    thumbnail: null,
    isYouTubeVideo: false,
    tenantId: null,
    tenantName: null,
    profilePicUrl: null,
    embedId: null,
    caloriesBeforeReload: 0, //total calories after reload,
    timeBeforeReload: 0,
    statistics: null,
    showInstructions: false,
    mouseHover: false,
    sessionId: null,
    loading: false,
    redirectUrl: null,
    assistMessage: {},
    accuracyScores: 0,
    videoCurrentTime: 0,
    userWorkout: false,
    scoreAPIReturned: true,
    scoreEndTime: 0,
    videoJSONData: null,
    feedbackIcon: "",
    feedbackMessage: [],
    feedbackIconClearedTime: 0,
    calories: 0,
    validTotalTime: 0,
    nextPopup: false,
    dir: 'next',
    scoreColorCode: 'grey',
    rcBaseline: null,
    intensity: 0,
    videoData: null,
    scoringLogic: null,
    baselineFolder: null,
    workoutCategories: [],
    modelComplexity: 0,
    translatedMessages : {}
  };
};

const state = {
  ...getState(),
};

const mutations = {
  resetWorkoutStore(state) {
    const s = getState();
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  setStatistics(state, stats) {
    state.statistics = stats;
  },
  setVideoData(state, data) {
    state.videoId = data.id;
    if (data.data) {
      state.videoJSONData = data.data;
      state.successColor = data.data.successColor;
      state.errorColor = data.data.errorColor;
      state.defaultColor = data.data.defaultColor;
      state.steps = data.data.steps || [];
    }
    state.title = data.title;
    state.url = data.videoURL;
    state.videoCurrentTime = 0;
    state.duration = data.duration;
    state.thumbnail = data.thumbnail;
    state.embedId = data.embedId;
    state.isYoutubeVideo = data.isYouTubeVideo;
    state.tenantId = data.tenantId;
    state.tenantName = data.tenantName;
    state.profilePicUrl = data.profilePicUrl;
    state.statistics = data?.statistics;
    state.redirectUrl = data.redirectUrl;
    //reset calories and score
    state.accuracy = 0;
    state.caloriesBurnt = 0;
    state.accuracyScores = 0;
    state.calories = 0;
    state.scoreEndTime = 0;
    state.validTotalTime = 0;
    state.rcBaseline = data?.rcBaseline;
    state.intensity = data.intensity;
    state.videoData = data.data;
    state.scoringLogic = data.scoringLogic;
    state.baselineFolder = data.baselineFolder;
    state.workoutCategories = data.workoutCategories;
    state.modelComplexity = data.modelComplexity;
    state.translatedMessages= data.translatedMessages
  },
  setNextPopup(state, value){
    state.nextPopup = value;
  },
  setDir(state, value){
    state.dir = value;
  },
  referenceVideoLoaded(state) {
    state.videoLoaded = true;
  },
  setVideoPlaying(state, playing) {
    state.isVideoPlaying = playing;
  },

  setSessionId(state, sessionId) {
    state.sessionId = sessionId;
  },
  changeFeedbackIconAndMessage(state, data) {
    state.feedbackIcon = data.displayIcon
      ? data.displayIcon
      : FEEDBACK_ICONS.NONE;
    const translatedMessage = [];
    for(const message of data.message){
        translatedMessage.push(state.translatedMessages[message] || message)
    }
    state.feedbackMessage = translatedMessage;
  },
  setFeedbackMessages(state, data) {
    const translatedMessage = [];
    for(const message of data){
        translatedMessage.push(state.translatedMessages[message] || message)
    }
    state.feedbackMessage = translatedMessage ?? [];
  },
  clearFeedbackIcon(state, endTime) {
    state.feedbackIcon = FEEDBACK_ICONS.NONE;
    state.feedbackIconClearedTime = endTime;
  },
  setCaloriesBurnt(state, data) {
    if (state.sessionId == data.sessionId && !state.loading) {
      if (
        !isNaN(data.avgAccuracy) &&
        !isNaN(data.validTotalTime) &&
        data.startTime &&
        data.endTime &&
        data.avgAccuracy >=0 &&
        data.validTotalTime >= 0
      ) {
        if(!isNaN(data.instanceScore) && data.instanceScore >= 0){
          state.accuracy = data.instanceScore;
        }

        Vue.$log.info(
          "[",
          data.startTime,
          ",",
          data.endTime,
          "] - ",
          data.instanceScore,
          ", .TimeOffSet: ",
          data.timeDiff,
          ", Calories : ",
          data.calorieBurnt
        );
        state.accuracyScores = Math.floor(data.avgAccuracy);
        state.scoreEndTime += data.timeDiff;
        state.calories = data.calorieBurnt;
        state.validTotalTime = data.validTotalTime;
        state.scoreColorCode = data.scoreColorCode;
      }
    } else {
      state.accuracy = 0;
      //state.accuracyScores[0] = 0;
    }
  },
  resetState(state) {
    Object.assign(state, getState());
  },
  reloadCalories(state, currentTime) {
    state.timeBeforeReload = state.timeBeforeReload + currentTime;
    state.caloriesBeforeReload =
      state.caloriesBurnt + state.caloriesBeforeReload;
    state.caloriesBurnt = 0;
  },
  setShowInstructions(state, action) {
    state.showInstructions = action;
  },
  setMouseHover(state, action) {
    if (state.isVideoPlaying) {
      state.mouseHover = action;
    }
  },
  setLoading(state, val) {
    state.loading = val;
  },
  setAssistMessage(state, val) {
    state.assistMessage = val;

  },
  setVideoTime(state, time) {
    state.videoCurrentTime = time;
  },
  setUserWorkout(state, userWorkout) {
    state.userWorkout = userWorkout;
  },
  setScoreAPIReturned(state, data) {
    state.scoreAPIReturned = data;
  },
  setScoreColorCode(state, data) {
    state.scoreColorCode = data;
  },
};

const getters = {
  caloriesBurnt(state, getters) {
    if (state.calories) {
      return parseFloat(state.calories);
    } else {
      return 0;
    }
  },
  duration(state) {
    return Math.round(state.duration / 60);
  },
  durationSec(state) {
    return state.duration;
  },
  accuracy(state) {
    return state.accuracy;
  },
  accuracyScores(state) {
    return state.accuracyScores;
  },
  feedbackIcon(state) {
    return { icon: state.feedbackIcon };
  },
  avgAccuracyScore(state) {
    if (state.accuracyScores >= 0) {
      Vue.$log.info(
        "average score:",
        state.accuracyScores,
        "endTime:",
        state.scoreEndTime,
        "total valid time:",
        state.validTotalTime
      );
      return state.accuracyScores;
    } else return 0;
  },
  getStickFigColorCode(state) {
    return state.isVideoPlaying ? state.scoreColorCode : "#c9cbf7";
  },
  getAvgAccuracyColorCode(state) {
    return state.scoreColorCode;
  },
  getModelComplexity(state) {
    return state.modelComplexity;
  }
};

const actions = {
  async loadVideoData({ commit }, id) {
    try {
      const videoData = await eliteService.getVideoInfo(id);
      document.title = "EliteFit.AI - " + videoData.title;
      youtubeApi.getYTStats(videoData.embedId)
          .then(stats => commit("setStatistics", stats));
      commit("setVideoData", videoData);
      return videoData;
    } catch (e) {
      try {
        await retry(e);
        const videoData = await eliteService.getVideoInfo(id);
        document.title = "EliteFit.AI - " + videoData.title;
        commit("setVideoData", videoData);
        return videoData;
      } catch {
        redirect(e);
        notifyError(MESSAGES.LOAD_VIDEO_FAILED);
        Promise.reject(e);
      }
    }
  },

  async loadDefaultVideo({ commit }, {videoId = 0, tryNow = false}) {
    try {
      const videoData = await eliteService.getDefaultVideo(videoId);
      document.title = "EliteFit.AI - " + videoData.title;
      youtubeApi.getYTStats(videoData.embedId)
          .then(stats => commit("setStatistics", stats));
      commit("setVideoData", videoData);
      if (tryNow) {
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id +
            "&tryNow=true"
        );
      } else {
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id
        );
      }
      return videoData;
    } catch (e) {
      try {
        await retry(e);
        const videoData = await eliteService.getDefaultVideo();
        document.title = "EliteFit.AI - " + videoData.title;
        commit("setVideoData", videoData);
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id
        );
        return videoData;
      } catch {
        redirect(e);
        notifyError(MESSAGES.LOAD_VIDEO_FAILED);
        Promise.reject(e);
      }
    }
  },

  async getNextVideoAllTenants({ commit, state }, { dir, EFTech }) {
    try {
      const videoData = await eliteService.getNextVideoAllTenants(
        state.videoId,
        dir
      );
      youtubeApi.getYTStats(videoData.embedId)
          .then(stats => commit("setStatistics", stats));
      commit("setVideoData", videoData);
      if (EFTech == 0) {
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id +
            "&withEFTech=" +
            EFTech
        );
      } else {
        if (state.userWorkout == true) {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id +
              "&tryNow=true"
          );
        } else {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id
          );
        }
      }
      return videoData;
    } catch (e) {
      retry(e)
        .then(async (_) => {
          const videoData = await eliteService.getNextVideoAllTenants(
            state.videoId,
            dir
          );
          commit("setVideoData", videoData);
          if (EFTech == 0) {
            router.push(
              "/workout/" +
                videoData.tenantName.replace(" ", "") +
                "?id=" +
                videoData.id +
                "&withEFTech=" +
                EFTech
            );
          } else {
            router.push(
              "/workout/" +
                videoData.tenantName.replace(" ", "") +
                "?id=" +
                videoData.id +
                "&tryNow=true"
            );
          }
          return videoData;
        })
        .catch((e) => {
          redirect(e);
          notifyError(MESSAGES.LOAD_VIDEO_FAILED);
          Promise.reject(e);
        });
    }
  },

  async previousVideo({ commit }, { EFTech, tryNow }) {
    try {
      const videoData = await eliteService.getPreviousVideo(state.videoId);
      youtubeApi.getYTStats(videoData.embedId)
          .then(stats => commit("setStatistics", stats));
      commit("setVideoData", videoData);
      if (EFTech == 0) {
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id +
            "&withEFTech=" +
            EFTech
        );
      } else {
        if (tryNow == false) {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id +
              "&tryNow=true"
          );
        } else {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id +
              "&tryNow=true"
          );
        }
      }
      return videoData;
    } catch (e) {
      retry(e)
        .then(async (_) => {
          const videoData = await eliteService.getPreviousVideo(id);
          commit("setVideoData", videoData);
          if (EFTech == 0) {
            router.push(
              "/workout/" +
                videoData.tenantName.replace(" ", "") +
                "?id=" +
                videoData.id +
                "&withEFTech=" +
                EFTech
            );
          } else {
            if (tryNow == false) {
              router.push(
                "/workout/" +
                  videoData.tenantName.replace(" ", "") +
                  "?id=" +
                  videoData.sessionId
              );
            } else {
              router.push(
                "/workout/" +
                  videoData.tenantName.replace(" ", "") +
                  "?id=" +
                  videoData.id +
                  "&tryNow=true"
              );
            }
          }
          return videoData;
        })
        .catch((e) => {
          redirect(e);
          notifyError(MESSAGES.LOAD_VIDEO_FAILED);
          Promise.reject(e);
        });
    }
  },

  async nextVideo({ commit, dispatch }, { EFTech, tryNow, videoId, queryParams }) {
    try {
      let videoData
      if(videoId){
        videoData = await dispatch("loadVideoData", videoId);
      }else{
        videoData = await eliteService.getNextVideo(state.videoId);
      }
      youtubeApi.getYTStats(videoData.embedId)
          .then(stats => commit("setStatistics", stats));
      commit("setVideoData", videoData);
      if (EFTech == 0) {
        router.push(
          "/workout/" +
            videoData.tenantName.replace(" ", "") +
            "?id=" +
            videoData.id +
            "&withEFTech=" +
            EFTech +
            "&" +
            queryParams
        );
      } else {
        if (tryNow == false) {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id +
              "&" +
              queryParams
          );
        } else {
          router.push(
            "/workout/" +
              videoData.tenantName.replace(" ", "") +
              "?id=" +
              videoData.id +
              "&tryNow=true" +
              "&" +
              queryParams
          );
        }
      }
      return videoData;
    } catch (e) {
      retry(e)
        .then(async (_) => {
          const videoData = await eliteService.getNextVideo(state.videoId);
          commit("setVideoData", videoData);
          if (EFTech == 0) {
            router.push(
              "/workout/" +
                videoData.tenantName.replace(" ", "") +
                "?id=" +
                videoData.id +
                "&withEFTech=" +
                EFTech
            );
          } else {
            if (tryNow == false) {
              router.push(
                "/workout/" +
                  videoData.tenantName.replace(" ", "") +
                  "?id=" +
                  videoData.id
              );
            } else {
              router.push(
                "/workout/" +
                  videoData.tenantName.replace(" ", "") +
                  "?id=" +
                  videoData.id +
                  "&tryNow=true"
              );
            }
          }
          return videoData;
        })
        .catch((e) => {
          redirect(e);
          notifyError(MESSAGES.LOAD_VIDEO_FAILED);
          Promise.reject(e);
        });
    }
  },
  async getCalories({ state, commit }, { time, sessionId }) {
    if (state.isVideoPlaying) {
      try {
        const data = await eliteService.getCalories(
          time,
          state.videoId,
          sessionId
        );
        if (data) {
          commit("setCaloriesBurnt", data);
        }
      } catch (e) {
        retry(e).then(async (_) => {
          const data = await eliteService.getCalories(
            time,
            state.videoId,
            sessionId
          );
          if (data) {
            commit("setCaloriesBurnt", data);
          }
        });
      }
    }
  },
  async getCaloriesAndScore(
    { state, commit },
    { startTime, endTime, sessionId, timeDiff, accuracy, calories, validTotalTime }
  ) {
    try {
      const data = await eliteService.getCaloriesAndScore(
        startTime,
        endTime,
        sessionId,
        accuracy,
        calories,
        validTotalTime
      );

      commit("setScoreAPIReturned", true);
      if (data) {
        data.startTime = startTime;
        data.endTime = endTime;
        data.timeDiff = timeDiff;
        //do not clear the icon of the same icon is being sent again within 10 sec. So the same icon doesnt change.
        if (
          FEEDBACK_STICKER_ENABLED &&
          endTime - state.feedbackIconClearedTime >= FEEDBACK_STICKER_INTERVAL
        ) {
          commit("clearFeedbackIcon", endTime);
          commit("changeFeedbackIconAndMessage", data);
        }
        commit("setCaloriesBurnt", data);
      }
    } catch (e) {
      retry(e).then(async (_) => {
        const data = await eliteService.getCaloriesAndScore(
          startTime,
          endTime,
          state.videoId,
          sessionId
        );
        commit("setScoreAPIReturned", true);

        if (data) {
          data.startTime = startTime;
          data.endTime = endTime;
          data.timeDiff = timeDiff;
          if (
            FEEDBACK_STICKER_ENABLED &&
            endTime - state.feedbackIconClearedTime >= 10
          ) {
            commit("clearFeedbackIcon", endTime);
            commit("changeFeedbackIconAndMessage", data);
          }
          commit("setCaloriesBurnt", data);
        }
      });
    }
    commit("setScoreAPIReturned", true);
  },

  // Add startTime, endTime, timeDiff to data
  uploadPosesAndGetScore(
    { state, commit },
    data
  ) {
    commit("setScoreAPIReturned", true);
    if(data) {
      if (
        FEEDBACK_STICKER_ENABLED
      ) {
        commit("clearFeedbackIcon", data.endTime);
        commit("changeFeedbackIconAndMessage", data);
      }
      commit("setCaloriesBurnt", data);
    }
  },

  async getAssistMessage({ state, commit }, { startTime, endTime, sessionId }) {
    if (state.isVideoPlaying) {
      try {
        const data = await eliteService.getAssistMessage(
          startTime,
          endTime,
          state.videoId,
          sessionId
        );
        if (data) {
          commit("setAssistMessage", data);
        }
      } catch (e) {
        retry(e).then(async (_) => {
          const data = await eliteService.getAssistMessage(
            startTime,
            endTime,
            state.videoId,
            sessionId
          );
          if (data) {
            commit("setAssistMessage", data);
          }
        });
      }
    }
  },
  async postPoses({ state, commit }, poses) {
    try {
      await eliteService.postPoses(poses);
    } catch (e) {
      retry(e).then(async (_) => {
        await eliteService.postPoses(poses);
      });
    }
  },

  async updateViewCount(state, videoId) {
    try {
      await eliteService.updateVideoViews(videoId);
    } catch (e) {
      retry(e).then(async (_) => {
        await eliteService.updateVideoViews(videoId);
      });
    }
  },
  // async updateSession(context, sessionId) {
  //     return eliteService.updateSession(sessionId);
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {},
};
